/**
 * @method br
 * @description Adds a line break in the console
 * @param numBreaks Number of line breaks to add. (Default 2)
 * @returns {Null}
 */
var br = function br() {
  var numBreaks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  for (var _br = 0; _br < numBreaks; _br++) {
    console.log("");
  }
};

module.exports = {
  br: br
};